import * as React from "react";
import useQuery from "routing/useQuery";
import HighlightMessageContext from "../contexts/HighlightMessageContext";
const HighlightMessageInQuery = ({ children }) => {
  const query = useQuery();
  const { highlightMessage } = query != null ? query : {};
  return highlightMessage ? /* @__PURE__ */ React.createElement(HighlightMessageContext.Provider, { value: highlightMessage.toString() }, children) : children;
};
export default HighlightMessageInQuery;
